import Tag from 'components/Tag';
import { Link } from 'react-router-dom';
import ROUTES from 'constants/routes';
import { useSelector } from 'react-redux';
import { selectLatestPost } from 'store/slices/BlogSlice';
import { getImageUrl } from 'helpers';


const CompanyDropdownComponent = ({ onClick }) => {

    const latestPost = useSelector(selectLatestPost);
    if (!latestPost) return
    const { title, image, tags } = latestPost.attributes

    const imageUrl = getImageUrl(image)
    return (
        <Link to={`${ROUTES.blog}/${latestPost.attributes.slug}`} className="header-nav__item__dropdown-post" onClick={onClick}>
            <div className="header-nav__item__dropdown-post__image">
                <img src={imageUrl} alt="" />
            </div>
            <div className='header-nav__item__dropdown-post__tags'>
                {
                    tags.data.map((item, index) => (
                        <Tag key={index} text={item.attributes.name} />
                    ))
                }
            </div>
            <div className="body2">{title}</div>
        </Link>
    );
};

export default CompanyDropdownComponent;
